import { MediaMatcher } from '@angular/cdk/layout';
import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserAuthenticationService } from '../../../core/services/user-authentication/user-authentication.service';
import { SnackbarService } from '../../services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { MatExpansionModule } from '@angular/material/expansion';
import { MenuItem } from '../../../core/interfaces/menu-item.interface';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { SidenavMenuItemsService } from '../../services/sidenav-menu-items/sidenav-menu-items.service';
import { AdService } from '../../../pages/annual-declaration/ad-service/ad-service';

@Component({
  selector: 'app-pias-layout',
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    RouterModule,

    MenuItemComponent
  ],
  templateUrl: './pias-layout.component.html',
  styleUrl: './pias-layout.component.scss'
})
export class PiasLayoutComponent implements OnInit, OnDestroy {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private userAuthenticationService = inject(UserAuthenticationService);
  private sidenavMenuItemsService = inject(SidenavMenuItemsService);

  menuItems!: MenuItem[];

  protected currentUserPersonName: string = '';
  protected currentUserRole: string = '';
  protected adflag: string = '';

  // protected readonly fillerNav = Array.from({ length: 12 }, (_, i) => `Nav Item ${i + 1}`);

  protected readonly isMobile = signal(true);

  private readonly _mobileQuery: MediaQueryList;
  private readonly _mobileQueryListener: () => void;

  constructor() {
    const media = inject(MediaMatcher);

    this._mobileQuery = media.matchMedia('(max-width: 600px)');
    this.isMobile.set(this._mobileQuery.matches);
    this._mobileQueryListener = () => this.isMobile.set(this._mobileQuery.matches);
    this._mobileQuery.addEventListener('change', this._mobileQueryListener);

    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.adflag = this.sessionStorageService.getCurrentAdflag();

    if (this.currentUserRole === 'Advisor') {
      if (['Invalid', 'Approved'].includes(this.adflag)) {
        this.menuItems = this.sidenavMenuItemsService.getAgentsSidenavMenuItems();
      } else {
        this.menuItems = this.sidenavMenuItemsService.getAdAgentsSidenavMenuItems();
      }
    } else if (['NEWREP', 'Introducer - Individual', 'Introducer - Corporate', 'Onboarding'].includes(this.currentUserRole)) {
      this.menuItems = this.sidenavMenuItemsService.getnewRepSidenavMenuItems();
    } else if (this.currentUserRole === 'Corporate') {
      this.menuItems = this.sidenavMenuItemsService.getCorporateSidenavMenuItems();

    } else if (this.currentUserRole === 'DSU' || this.currentUserRole === 'DSU Manager') {
      this.menuItems = this.sidenavMenuItemsService.getDSUSidenavMenuItems();
    } else if (this.currentUserRole === 'PA') {
      this.menuItems = this.sidenavMenuItemsService.getPASidenavMenuItems();
    } else {
      if (['Invalid', 'Approved'].includes(this.adflag)) {
        this.menuItems = this.sidenavMenuItemsService.getManagersSidenavMenuItems();
      } else {
        this.menuItems = this.sidenavMenuItemsService.getAdManagersSidenavMenuItems();
      }
    }
  }

  ngOnInit(): void {
    this.currentUserPersonName = this.sessionStorageService.getCurrentUserPersonName() == '' ? this.sessionStorageService.getCurrentUserName() : this.sessionStorageService.getCurrentUserPersonName();
  }

  ngOnDestroy(): void {
    this._mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }

  async logout() {
    const responseData = await this.userAuthenticationService.userLogout()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    // Handling the response from the API call.
    if (responseData.status === HttpStatusCode.Ok) {
      // Display notification on successful logout.
      this.snackBarService.openSuccessSnackBar("Logged out successfully!");
    } else {
      // Display notification on logout failure.
      this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
    }

    this.sessionStorageService.clearSessionStorage();
    this.router.navigate(['/login'])
  }

}
